import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Alert, Button, InputGroup } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-phone-number-input/style.css";
import Stack from 'react-bootstrap/Stack';
import PhoneInput from "react-phone-number-input";
import { useUserAuth } from "../../context/UserAuthContext";
import Cookies from 'js-cookie'

import {addFunction} from './AddFunction';
import './login.css';
import auth_obj from '../assets/auth.json';

const PhoneSignUp = () => {
  const [error, setError] = useState("");
  const [number, setNumber] = useState("");
  const [aikotoba1, setAikotoba1] = useState("");
  const [aikotoba2, setAikotoba2] = useState("");
  const [chatwork_name, setChatworkName] = useState("");
  const [buttonFlag, setButtonFlag] = useState(false);

  const [flag, setFlag] = useState(false);
  const [otp, setOtp] = useState("");
  const [result, setResult] = useState("");
  const { setUpRecaptha } = useUserAuth();
  const navigate = useNavigate();

  const [show_ok_button_1, setShowOkButton1] = useState(true);
  const [show_ok_button_2, setShowOkButton2] = useState(true);

  const getOtp = async (e) => {
    e.preventDefault();
    //console.dir(e.nativeEvent.srcElement);
    let auth_file = window.location.href.replace('login', 'app.json');
    let app_obj = await (await fetch(auth_file)).json();
    let auth_check = await addFunction.loginVaridation(e.nativeEvent.srcElement, app_obj);

    setError("");
    if (number === "" || number === undefined)
      return setError("電話番号入力してください");
    if (auth_check===false)
      return setError("許可されていません");


    setShowOkButton1(false);


    try {
      const response = await setUpRecaptha(number);
      setResult(response);
      setFlag(true);
    } catch (err) {
      setError(err.message);
    }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();

    setShowOkButton2(false);

    setError("");
    if (otp === "" || otp === null) return;
    try {
      await result.confirm(otp);

      let staff_name = Cookies.get('_replace_staff');
      let staff_phone = Cookies.get('_replace_phone');
      let my_token = await addFunction.getMyToken(staff_name, staff_phone, auth_obj);

      Cookies.set('_replace_token', my_token, { expires: 30 })
      navigate("/cm-list");
    } catch (err) {
      setError(err.message);
      setShowOkButton2(true);
    }
  };

  useEffect(() => {
    let my_token = Cookies.get('_replace_token');
    console.log(my_token);
    if(my_token!==undefined){
      navigate("/cm-list");
    }else{
      const cookies = Cookies.get();
      for (const cookieName in cookies) {
        Cookies.remove(cookieName);
      }
    }
  }, []);



  

  return (
    <>
      <div className="p-4 box center">
        <h2 className="mb-3 bg-success text-white px-2 py-1 text-center">リプレイス発注App</h2>
        <h2 className="mb-3 text-center">ログイン</h2>
        {error && <Alert variant="danger">{error}</Alert>}

        <Form onSubmit={getOtp} style={{ display: !flag ? "block" : "none" }}>
          <Form.Group className="m-b-1" controlId="formBasicEmail">
            <Form.Label>携帯番号　例：090・・・</Form.Label>
            <PhoneInput
              defaultCountry="JP"
              value={number}
              onChange={setNumber}
              placeholder="09069038394"
            />
            <div id="recaptcha-container" className="mt-3"></div>
          </Form.Group>
          <InputGroup size="sm" className="mb-3">
            <InputGroup.Text id="inputGroup-sizing-sm">合言葉１</InputGroup.Text>
              <Form.Control
                aria-label="Small"
                aria-describedby="inputGroup-sizing-sm"
              />
          </InputGroup>
          <InputGroup size="sm" className="mb-3">
            <InputGroup.Text id="inputGroup-sizing-sm">合言葉２</InputGroup.Text>
              <Form.Control
                aria-label="Small"
                aria-describedby="inputGroup-sizing-sm"
              />
          </InputGroup>
          <InputGroup size="sm" className="mb-4">
            <InputGroup.Text id="inputGroup-sizing-sm">チャットワーク名</InputGroup.Text>
              <Form.Control
                aria-label="Small"
                aria-describedby="inputGroup-sizing-sm"
              />
          </InputGroup>
          <div className="">
            {/*
            <Link to="/login" className="">
              <Button variant="secondary">キャンセル</Button>
            </Link>
            */}

            {show_ok_button_1 ?
              <>
                <Stack gap={2} className="col-md-5 mx-auto">
                  <Button type="submit" variant="primary" className="">OK</Button>
                </Stack>
              </>
              :
              <></>
            }

            
          </div>
        </Form>

        <Form onSubmit={verifyOtp} style={{ display: flag ? "block" : "none" }}>
          <Form.Group className="mb-3" controlId="formBasicOtp">
            <Form.Control
              type="otp"
              placeholder="SMS番号"
              onChange={(e) => setOtp(e.target.value)}
            />
          </Form.Group>
          <div className="button-right">
            {/*
            <Link to="/">
              <Button variant="secondary">Cancel</Button>
            </Link>
            */}

            {show_ok_button_2 ? 
              <>
                <Stack gap={2} className="col-md-5 mx-auto">
                  <Button type="submit" variant="primary" className="">OK</Button>
                </Stack>
              </> : 
              <>
                <Stack gap={2} className="col-md-5 mx-auto">
                  <Button type="submit" variant="primary" className="" disabled>
                    OK
                    <div className="spinner-border spinner-border-sm mx-1" role="status"><span className="sr-only"></span></div>
                  </Button>
                </Stack>
              </>
            }

          </div>
        </Form>

        <p className="text-danger mt-4 mb-0">*本システムは、ご本人のみの利用に限る</p>
      </div>
      

    </>
  );
};

export default PhoneSignUp;